var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserPlus28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.753a7.603 7.603 0 0 1 3.91-6.646l.446-.248c.278-.154.417-.232.55-.3a10 10 0 0 1 9.189 0c.132.068.271.146.55.3l.445.248A7.603 7.603 0 0 1 26 20.753c0 1.336-.929 2.488-2.25 2.686-1.754.264-4.368.561-7.25.561-2.882 0-5.496-.297-7.25-.56C7.93 23.24 7 22.09 7 20.752ZM20.5 6.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM6 5a1 1 0 0 0-1 1c0 .334-.092 1.272-.164 1.96a.984.984 0 0 1-.877.876C3.272 8.908 2.334 9 2 9a1 1 0 0 0 0 2c.334 0 1.272.092 1.96.164a.984.984 0 0 1 .876.877C4.908 12.728 5 13.666 5 14a1 1 0 1 0 2 0c0-.334.092-1.272.164-1.96a.984.984 0 0 1 .877-.876C8.728 11.092 9.666 11 10 11a1 1 0 1 0 0-2c-.334 0-1.272-.092-1.96-.164a.984.984 0 0 1-.876-.877C7.092 7.272 7 6.334 7 6a1 1 0 0 0-1-1Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus28);
export default __webpack_public_path__ + "static/media/user_plus_28.182bb0cd.svg";
export { ForwardRef as ReactComponent };